import type { FareTypeEnum } from '../../../types';
import type { PaxInfo } from '../../../types/api/v1/obt/air/air_search_response';

export function getFareTypeForPaxInfo(paxInfo: PaxInfo[]): FareTypeEnum {
  return paxInfo[0].fareComponents[0].legInfo[0].fareType;
}
